// import { login, logout, getInfo } from '@/api/user'
import { login, logout ,getUserMenus} from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { setStore,encodeParam } from '@/utils/index'

// 登录：当用户填写完账号和密码后向服务端验证是否正确，验证通过之后，服务端会返回一个token，拿到token之后（我会将这个token存贮到cookie中，保证刷新页面后能记住用户登录状态），前端会根据token再去拉取一个 user_info 的接口来获取用户的详细信息（如用户权限，用户名等等信息）。
// 权限验证：通过token获取用户对应的 role，动态根据用户的 role 算出其对应有权限的路由，通过 router.addRoutes 动态挂载这些路由。

const state = {
  token: getToken(),
  name: '',
  introduction: '',
  roles: [],
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
}

const actions = {
  // user login
  login ({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo).then(response => {
        const {data} = response
        commit('SET_TOKEN', data['x-auth-token'])
        setToken(data['x-auth-token'])
        localStorage.setItem('user-name',data['user-name'])
        localStorage.setItem('user-id',data['user-id'])
        commit('SET_NAME', data['user-name'])
        // 获取菜单
        getUserMenus().then(menuRes=>{
          const resArr=menuRes.data;
          var jsonkey={};
          var newArr=[];
          for(var i=0;i<resArr.length;i++){
            if(!jsonkey[resArr[i].key]){
                jsonkey[resArr[i].key]=1;
                newArr.push(resArr[i])
            }
          }
          localStorage.setItem('user-menus',encodeParam(JSON.stringify(newArr)))
          resolve(data)
        })
        
      }).catch(error => {
        reject(error)
      })
    })
  },


  // user logout
  logout ({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, { root: true })

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  async changeRoles ({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js